// extracted by mini-css-extract-plugin
module.exports = {"header":"m_w g_r","logo":"m_x"};